import RangeSlider from '@components/rangeSlider/RangeSlider';

const RangeSliders = ({ data, updateFilterBox, hexagonRanges, activeFilterTemplate }) => {
	const heightRange = hexagonRanges?.height;
	const countRange = hexagonRanges?.count;

	// Guard against missing data properties (e.g., when switching from Matrix filter mode)
	const heightData = data?.height;
	const countData = data?.count;

	return (
		<>
			{heightRange?.min != null && heightRange?.max != null && heightData && (
				<RangeSlider
					label={
						<>
							Mean Height <span className="small text-muted">(m)</span>
						</>
					}
					step={0.01}
					analasysRangeLimit={heightRange}
					boxData={heightData}
					activeFilterTemplate={activeFilterTemplate?.height}
					onChange={values => {
						// Update the height values in the filter box
						updateFilterBox('height', {
							min: values[0],
							max: values[1],
						});
					}}
				/>
			)}

			{countRange?.min != null && countRange?.max != null && countData && (
				<RangeSlider
					label="Count"
					step={1}
					analasysRangeLimit={countRange}
					boxData={countData}
					activeFilterTemplate={activeFilterTemplate?.count}
					onChange={values => {
						updateFilterBox('count', {
							min: values[0],
							max: values[1],
						});
					}}
				/>
			)}
		</>
	);
};

export default RangeSliders;
